import Footer from '../@common_components/global/footer.component';
import HomeLeftBar from '@common_components/layout/LeftBarManager';

function OnlineHelpView() {

  /*---------------------------------- Front ----------------------------------*/
  return (
    <div className='flex min-h-screen w-screen bg-white-base text-black relative'>
      <HomeLeftBar variant='basic'/>
      <div className='w-full pr-10 ml-32'>
        {/*<HomeTopBar title='Aide en Ligne' />*/}

        <div className='w-full mx-4 my-10 p-10 rounded-md'>
        </div>

      </div>

      <Footer />
    </div>
  );
}

export default OnlineHelpView;
